<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE CARGO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-12">
          <label><small v-show="form.nome.required" class="text-danger">*</small> Nome:</label>
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o nome do Cargo'"
              v-model="form.nome.value"
              :formatter="value => value.toUpperCase()"
              :size="form.nome.maxlength"
              :required="form.nome.required"
              :state="form.nome.state"
              autocomplete="false"
            />
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import PositionModel from '@/shared/models/configurations/positionmodel.js'
import PositionForms from './position-form.js'
import PositionRepository from '@/shared/http/repositories/configurations/position.js'

export default {
  name: 'PaAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: PositionModel,
      form: PositionForms
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      if (obj && obj.numero) {
        this.form.numero.value = parseInt(obj.numero)
      }
      loading.pop()
    },
    onCreate () {
      loading.push()
      PositionRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      PositionRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/position/components/add/positionAdd.vue